import { render } from "./CardDescription.vue?vue&type=template&id=15149ff5&scoped=true"
import script from "./CardDescription.vue?vue&type=script&lang=ts"
export * from "./CardDescription.vue?vue&type=script&lang=ts"

import "./CardDescription.vue?vue&type=style&index=0&id=15149ff5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15149ff5"

export default script